import axios from 'axios'
import qs from 'qs'

var _http = axios.create({
  baseURL: process.env.BASE_API + '/api',
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
})
const HttpUtils = {
  post(vue, param, success, error) {
    // let token = cache.get('token')
    let options = { method: 'post' }
    // if (token && token !== '') {
    //   Object.assign(options, {
    //     headers: {
    //       Authorization: 'JWT ' + token
    //     }
    //   })
    // }
    _http
      .post(param.url, qs.stringify(param.params), options)
      .then(function(res) {
        console.info(res.data)
        if (typeof success === 'function') {
          let data = res.data
          success(data)
        }
      })
      .catch(function(error) {
        console.info(error)
        if (error.response && error.response.status === 401) {
          window.$cache.del('user')
          window.$cache.del('waiter')
          window.$cache.del('entertainer')
          if (window.location.href.indexOf('waiter') > -1) {
            vue.$router.replace('/waiter/login')
          } else if (window.location.href.indexOf('entertainers') > -1) {
            vue.$router.replace('/entertainers/login')
          } else {
            let oldUrl = window.location.href
            oldUrl = oldUrl.substring(oldUrl.indexOf('//') + 2)
            let to = oldUrl.substring(oldUrl.indexOf('/'))
            vue.$router.replace({
              path: '/',
              // query: { to: 'vote' + window.location.search }
              query: { to: to }
            })
          }
        }
        if (typeof error === 'function') {
          error(error)
        }
      })
  },
  get(vue, param, success, error) {
    // let token = cache.get('token')
    let options = { params: param.params }
    // if (token && token !== '') {
    //   Object.assign(options, {
    //     headers: {
    //       Authorization: 'JWT ' + token
    //     }
    //   })
    // }
    _http
      .get(param.url, options)
      .then(function(res) {
        console.info(res.data)
        if (typeof success === 'function') {
          let data = res.data
          success(data)
        }
      })
      .catch(function(error) {
        console.info(error)
        if (error.response && error.response.status === 401) {
          window.$cache.del('user')
          window.$cache.del('waiter')
          window.$cache.del('entertainer')
          if (window.location.href.indexOf('waiter') > -1) {
            vue.$router.replace('/waiter/login')
          } else if (window.location.href.indexOf('entertainers') > -1) {
            vue.$router.replace('/entertainers/login')
          } else {
            let oldUrl = window.location.href
            oldUrl = oldUrl.substring(oldUrl.indexOf('//') + 2)
            let to = oldUrl.substring(oldUrl.indexOf('/'))
            vue.$router.replace({
              path: '/',
              query: { to: to }
            })
          }
        }
        if (typeof error === 'function') {
          error(error)
        }
      })
  },
  upload: function(url, formData, success, error) {
    axios
      .post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then(function(res) {
        console.info(res.data)
        if (typeof success === 'function') {
          let data = res.data
          success(data)
        }
      })
      .catch(function(error) {
        console.info(error)
        if (typeof error === 'function') {
          error(error)
        }
      })
  }
}

export default HttpUtils



// WEBPACK FOOTER //
// ./src/js/httpUtils.js